import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router'
import { FROM_INSIDE_APP_SUB_PATH } from '~/routing'

import { sessionStorageGet } from './webStorage'

export const goBack = () => {
    const beforeLength = parseInt(sessionStorageGet('historyLengthBeforeLogin') || 'NaN', 10)
    const afterLength = parseInt(sessionStorageGet('historyLengthAfterLogin') || 'NaN', 10)

    if (history.length === afterLength && afterLength - beforeLength > 1) {
        history.go(beforeLength - afterLength)
    } else {
        history.back()
    }
}

export const getCurrentLocation = () => location.pathname

export const isCurrentLocation = (location: string) => getCurrentLocation() === location

export const isCurrentLocationMatching = (pageToTest: string) =>
    new RegExp(pageToTest).test(getCurrentLocation())

export const getCurrentQueryParams = () => location.search

export interface WithRouterProps<T = unknown> {
    location: ReturnType<typeof useLocation>
    navigate: ReturnType<typeof useNavigate>
    params: T
    searchParams: ReturnType<typeof useSearchParams>[0]
    setSearchParams: ReturnType<typeof useSearchParams>[1]
}

// Wrapper used to provide the react-router-6 hook to class components
export const withRouter = <P extends object>(Component: React.ComponentType<P>) =>
    function WithRouterComponent(props: Omit<P, keyof WithRouterProps<object>>) {
        const location = useLocation()
        const navigate = useNavigate()
        const params = useParams()
        const [searchParams, setSearchParams] = useSearchParams()

        return (
            <Component
                {...(props as P)}
                {...{
                    location,
                    navigate,
                    params,
                    searchParams,
                    setSearchParams,
                }}
            />
        )
    }

export const isInsideAppRoute = (pathname?: string) => {
    return (pathname ?? window.location.pathname).startsWith(FROM_INSIDE_APP_SUB_PATH)
}

export const useIsInsideAppRoute = () => {
    const location = useLocation()
    return isInsideAppRoute(location.pathname)
}
